var ACTIONS = {
  ENV_SETTINGS_GET: 'ENV_SETTINGS_GET',
  ENV_SETTINGS_GET_RESOLVED: 'ENV_SETTINGS_GET_RESOLVED',
  ENV_SETTINGS_GET_FAILED: 'ENV_SETTINGS_GET_FAILED',
  MANIFEST_GET: 'MANIFEST_GET',
  MANIFEST_GET_RESOLVED: 'MANIFEST_GET_RESOLVED',
  MANIFEST_GET_FAILED: 'MANIFEST_GET_FAILED',
  MANIFEST_SET: 'MANIFEST_SET',
  USER_INFO_GET: 'USER_INFO_GET',
  USER_INFO_GET_RESOLVED: 'USER_INFO_GET_RESOLVED',
  USER_INFO_GET_FAILED: 'USER_INFO_GET_FAILED',
  AUTH_SET: 'AUTH_SET',
  AUTH_SET_UNAUTHORIZED: 'AUTH_SET_UNAUTHORIZED',
  GRID_DATA_GET: 'GRID_DATA_GET',
  GRID_DATA_GET_RESOLVED: 'GRID_DATA_GET_RESOLVED',
  GRID_DATA_GET_FAILED: 'GRID_DATA_GET_FAILED',
  GRID_VIEW_SET: 'GRID_VIEW_SET',
  GRID_SELECTION_SET: 'GRID_SELECTION_SET',
  GRID_SELECTION_SPATIAL: 'GRID_SELECTION_SPATIAL',
  ITEM_GET: 'ITEM_GET',
  ITEM_GET_RESOLVED: 'ITEM_GET_RESOLVED',
  ITEM_GET_FAILED: 'ITEM_GET_FAILED',
  ITEM_CREATE: 'ITEM_CREATE',
  ITEM_CREATE_RESOLVED: 'ITEM_CREATE_RESOLVED',
  ITEM_CREATE_FAILED: 'ITEM_CREATE_FAILED',
  ITEM_UPDATE: 'ITEM_UPDATE',
  ITEM_UPDATE_RESOLVED: 'ITEM_UPDATE_RESOLVED',
  ITEM_UPDATE_FAILED: 'ITEM_UPDATE_FAILED',
  ITEM_RENAME: 'ITEM_RENAME',
  ITEM_RENAME_RESOLVED: 'ITEM_RENAME_RESOLVED',
  ITEM_RENAME_FAILED: 'ITEM_RENAME_FAILED',
  ITEM_DELETE: 'ITEM_DELETE',
  ITEM_DELETE_RESOLVED: 'ITEM_DELETE_RESOLVED',
  ITEM_DELETE_FAILED: 'ITEM_DELETE_FAILED',
  REQUEST_METHOD: 'REQUEST_METHOD',
  USER_LOGOUT: 'USER_LOGOUT',
  USER_LOGOUT_RESOLVED: 'USER_LOGOUT_RESOLVED',
  USER_LOGOUT_FAILED: 'USER_LOGOUT_FAILED',
  MODAL_OPEN: 'MODAL_OPEN',
  MODAL_CLOSE: 'MODAL_CLOSE'
};
export default ACTIONS;